import React from 'react'
import Form from 'devextreme-react/form';

export const LVForm = (props) => {
  const { formData, children, Titulo, colCount, onContentReady, onFieldDataChanged } = props;

  return (
    <React.Fragment>
      <div className="long-title">
        <h3>{Titulo}</h3>
      </div>

      <div className="form-container">
        <Form
          colCount={colCount}
          id="formulario"
          formData={formData}
          onContentReady={onContentReady}
          onFieldDataChanged={onFieldDataChanged}
        >

          {children}

        </Form>
      </div>
    </React.Fragment>
  );
}